import { SystemConfigForm } from './SystemConfigForm'
import { SYS_STR as S } from './systemConfigApi'

/**
 * A24.16 / A24.17 — premium & pricing CONFIG forms. Real app_settings keys via
 * `/admin/settings/system` (fail-soft until the backend struct lists the key).
 */

/** A24.16 — Premium paketlari. */
export function PremiumPackages() {
  return (
    <SystemConfigForm
      screenId="A24.16"
      title={S.premiumTitle}
      description={S.premiumDesc}
      sections={[
        {
          fields: [
            { key: 'premium_enabled', label: S.fPremiumEnabled, type: 'bool', def: 'true' },
            { key: 'premium_trial_days', label: S.fPremiumTrialDays, type: 'number', def: '7', min: 0, mono: true },
            { key: 'premium_lite_name', label: S.fPremiumLiteName, def: 'Lite' },
            { key: 'premium_pro_name', label: S.fPremiumProName, def: 'Pro' },
            { key: 'premium_max_upload_mb', label: S.fPremiumMaxUploadMb, type: 'number', def: '4096', min: 1, mono: true },
            {
              key: 'premium_features',
              label: S.fPremiumFeatures,
              type: 'textarea',
              placeholder: 'no_ads, large_uploads, exclusive_stickers',
            },
          ],
        },
      ]}
    />
  )
}

/** A24.17 — Narxlar. */
export function Pricing() {
  return (
    <SystemConfigForm
      screenId="A24.17"
      title={S.pricingTitle}
      description={S.pricingDesc}
      sections={[
        {
          title: S.secPricingPremium,
          fields: [
            { key: 'price_currency', label: S.fCurrency, def: 'UZS', mono: true },
            { key: 'price_premium_month', label: S.fPriceMonth, type: 'number', def: '0', min: 0, mono: true },
            { key: 'price_premium_year', label: S.fPriceYear, type: 'number', def: '0', min: 0, mono: true },
          ],
        },
        {
          title: S.secPricingMisc,
          fields: [
            { key: 'price_stars_rate', label: S.fPriceStarsRate, type: 'number', def: '0', min: 0, mono: true },
            { key: 'price_gift_commission_pct', label: S.fGiftCommission, type: 'number', def: '10', min: 0, max: 100, mono: true },
            { key: 'price_withdraw_min', label: S.fWithdrawMin, type: 'number', def: '0', min: 0, mono: true },
          ],
        },
      ]}
    />
  )
}
